import React from 'react'
import Flexbox from '../Flexbox'



const TextStep = ({ heading, subtext }) => {
    return (
        <Flexbox column >
            <h3>{heading}</h3>
            {subtext && <p>{subtext}</p>}
        </Flexbox>
    )
}

export default TextStep